import React, { createContext, useMemo, useState } from 'react';

export type ContextValue = {
  headerTitle: string;
  setHeaderTitle: (headerTitle: string) => void;
  progress: number;
  setProgress: (percentage: number) => void;
  isCustomerAgreementActive: boolean;
  setCustomerAgreementActive: (isActive: boolean) => void;
  partnerCode: string | null;
  setPartnerCode: (partnerCode: string | null) => void;
  partnerAgencyId: string | null;
  setPartnerAgencyId: (partnerAgencyId: string | null) => void;
};

export const Context = createContext<ContextValue | null>(null);

const ContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [progress, setProgress] = useState(0);
  const [headerTitle, setHeaderTitle] = useState('');
  const [isCustomerAgreementActive, setCustomerAgreementActive] = useState(
    false
  );
  const [partnerCode, setPartnerCode] = useState<string | null>(null);
  const [partnerAgencyId, setPartnerAgencyId] = useState<string | null>(null);

  const store: ContextValue = useMemo(
    () => ({
      progress,
      setProgress,
      headerTitle,
      setHeaderTitle,
      isCustomerAgreementActive,
      setCustomerAgreementActive,
      partnerCode,
      setPartnerCode,
      partnerAgencyId,
      setPartnerAgencyId
    }),
    [
      progress,
      headerTitle,
      isCustomerAgreementActive,
      partnerCode,
      partnerAgencyId
    ]
  );

  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export default ContextProvider;
